import React from 'react';
import { GetServerSideProps } from 'next';

import AuthoredPageRoutes from '@/components/authored-page-routes/authored-page-routes';
import { PreRenderProps } from '@/pages/_app';
import { getViewDefinition } from '@/ssr/view-definition-page-query';
import { fetchDataAndHandleErrors, withTokenRefresh } from '@/utils/ssr-utils';

type PageProps = PreRenderProps;

export const getServerSideProps: GetServerSideProps<PageProps> = withTokenRefresh(async (context: any) => {
  const data = await fetchDataAndHandleErrors(context, getViewDefinition, undefined);

  // Do not change PageProps type dramatically (only add new props)
  // Some SDUI components (Masthead) reads the props manually via NextData in the DOM, not via component props.
  // Changing the type will break header rendering, specifically the bagCount and favourites.
  const props: PageProps = {
    ...data,
  };
  return { props };
});

const Home: React.FC<PageProps> = (props) => {
  return (
    <>
      <AuthoredPageRoutes {...(props as any)} />
    </>
  );
};

export default Home;
